var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full -mt-4" },
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            spinnerCentered: "",
            loading: _vm.$apollo.queries.currentUserInfo.loading,
            hasData: !!_vm.currentUserInfo,
          },
        },
        [
          !_vm.$apollo.queries.currentUserInfo.loading
            ? _c(
                "div",
                [
                  _c("PageHeadContainer", {
                    attrs: { title: _vm.title },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "icons",
                          fn: function () {
                            return [
                              _c(
                                "PageHeadIcon",
                                {
                                  staticClass: "capitalize",
                                  attrs: { content: _vm.currentUserInfo.role },
                                },
                                [_c("BadgeIcon", { class: _vm.iconClasses })],
                                1
                              ),
                              _vm.companyName
                                ? _c(
                                    "PageHeadIcon",
                                    { attrs: { content: _vm.companyName } },
                                    [
                                      _c("CompaniesIcon", {
                                        class: _vm.iconClasses,
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "PageHeadIcon",
                                {
                                  attrs: {
                                    content: _vm.currentUserInfo.available
                                      ? "Available"
                                      : "Unavailable",
                                  },
                                },
                                [
                                  _c("ApartmentsIcon", {
                                    class: _vm.iconClasses,
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "PageHeadIcon",
                                { attrs: { content: _vm.updatedAt } },
                                [_c("ClockIcon", { class: _vm.iconClasses })],
                                1
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "actions",
                          fn: function () {
                            return [
                              _c("FormToggle", {
                                staticClass: "mr-4",
                                attrs: {
                                  label: _vm.availability,
                                  checked: _vm.currentUserInfo.available,
                                },
                                on: { toggle: _vm.toggleAvailable },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      759788949
                    ),
                  }),
                  _c(
                    "div",
                    { staticClass: "max-w-7xl mx-auto mb-8" },
                    [
                      _c("ProfileBasic", {
                        attrs: { userId: _vm.userId },
                        on: { update: _vm.updateDate },
                      }),
                      _c("ProfileDetail", {
                        attrs: { userId: _vm.userId },
                        on: { update: _vm.updateDate },
                      }),
                      _c("ProfileResume", {
                        attrs: { userId: _vm.userId },
                        on: { update: _vm.updateDate },
                      }),
                      _c("ProfileExperience", {
                        attrs: { userId: _vm.userId },
                        on: { update: _vm.updateDate },
                      }),
                      _c("ProfileEducation", {
                        attrs: { userId: _vm.userId },
                        on: { update: _vm.updateDate },
                      }),
                      _c("ProfileCertification", {
                        attrs: { userId: _vm.userId },
                        on: { update: _vm.updateDate },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }